import client from './client'

export interface NotificaDaApprovare {
  id: string
  tipo: string
  destinatario: string
  oggetto: string | null
  corpo: string | null
  corpo_modificato: string | null
  oggetto_modificato: string | null
  coda_approvazione: string | null
  ticket_id: string | null
  intervento_id: string | null
  created_at: string | null
}

export const notificheApi = {
  daApprovare: (coda?: string) =>
    client.get<NotificaDaApprovare[]>('/notifiche/da-approvare', {
      params: { coda, limit: 500 },
    }).then(r => r.data),

  countDaApprovare: (coda?: string) =>
    client.get<{ count: number }>('/notifiche/count-da-approvare', {
      params: { coda },
    }).then(r => r.data),

  approva: (id: string, corpoModificato?: string, oggettoModificato?: string) =>
    client.patch(`/notifiche/${id}/approva`, {
      corpo_modificato: corpoModificato,
      oggetto_modificato: oggettoModificato,
    }).then(r => r.data),

  rifiuta: (id: string, motivo: string) =>
    client.patch(`/notifiche/${id}/rifiuta`, { motivo }).then(r => r.data),

  approvaBatch: (ids: string[]) =>
    client.post('/notifiche/approva-batch', { ids }).then(r => r.data),

  rifiutaBatch: (ids: string[], motivo: string) =>
    client.post('/notifiche/rifiuta-batch', { ids, motivo }).then(r => r.data),

  modificaBozza: (id: string, corpo?: string, oggetto?: string) =>
    client.patch(`/notifiche/${id}/modifica-bozza`, { corpo, oggetto }).then(r => r.data),
}
